import Flex from 'components/Flex';
import styled from 'styled-components';

const LabelRow = styled(Flex).attrs({ alignItems: 'center' })`
  margin-bottom: 8px;

  [data-role='field-label'] {
    margin-bottom: 0;
  }
`;

export default LabelRow;
